<template lang="pug">
b-tag(:class="style")
  span {{ status | capitalize }}
  span(v-if="isPublished") : {{ pubDate | date }}
</template>

<script>
import moment from 'moment';

export default {
  name: 'pub-tag',
  computed: {
    status() {
      if (this.isPublished) {
        if (moment(this.pubDate).isSameOrBefore(moment())) {
          return 'published';
        }
        return 'pending';
      }
      return 'draft';
    },
    style() {
      switch (this.status) {
        case 'published':
          return 'is-success';
        case 'pending':
          return 'is-warning';
        default:
          return 'is-light';
      }
    },
  },
  props: {
    isPublished: {
      type: Boolean,
      default: false,
    },
    pubDate: {
      type: String,
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/PubTag.vue